module.exports = "/assets/data/634dcbdc58929420f77c5e4cc1df8df3-SK12.data.json";